import { stringToHTML, $Q, $Qll  } from 'graditify-utils'
import { shopifyVariantByUrl, shopifySectionByUrl } from 'graditify-api';
/**
 * Captures the HTML section of the product in question and returns data
 *
 * @param {String} handle Data element of the product
 * to which the query will be made
 * @param {String} variantId Id of the selected variant
 * @returns Object - price, available, button
 */
export async function sectionHandle(handle, variantId) {
  const htmlResponse = await shopifySectionByUrl(`/products/${handle}?variant=${variantId}`, 'product-core', '&section_id');
  const variantAvailable = $Q('[name="available"]', stringToHTML(htmlResponse));
  const button = $Q('.btn-cart-js', stringToHTML(htmlResponse));
  const reference = $Q('.product-core__reference-js', stringToHTML(htmlResponse));
  const messageAvailable = $Q('.product-core__message-js', stringToHTML(htmlResponse));
  const color = $Q('#selected-color', stringToHTML(htmlResponse));
  const tag = $Q('.tag-js', stringToHTML(htmlResponse));
  const variantPrice = $Q(".price-product-js", stringToHTML(htmlResponse));
  const productCardButton = $Q(".product-card__form-button-js", stringToHTML(htmlResponse));
  const imageSelected = $Q('#selected-js', stringToHTML(htmlResponse));
  const imageSelectedSticky = $Q('#selected-sticky-js', stringToHTML(htmlResponse));
  const dataQuantity = $Q('#quantity', stringToHTML(htmlResponse));
      
  return {
    price: variantPrice ? variantPrice.innerHTML : "",
    available: variantAvailable.value,
    button: button.outerHTML,
    reference: reference.textContent,
    messageAvailable: messageAvailable.textContent,
    color: color ? color.textContent : "",
    tag: tag ? tag.outerHTML : "",
    productCardButton: productCardButton.outerHTML,
    imageSelected: imageSelected.innerHTML,
    imageSelectedSticky: imageSelectedSticky.innerHTML,
    maxQuantity: dataQuantity.getAttribute('data-quantity')
  }
}

/**
 * Update element
 *
 * @param {HTMLCollection} element - Object with element
 * @param {HTMLElement} parent - Parent node to closest
 * @param {String} selector - Selector HTML
 *
 */
export const updateElement = (element, parent, selector) => {
  const elementSection = $Q(selector, parent);

  if (!elementSection) return;

  elementSection.innerHTML = element;
}

export const updateMaxQuantity = (element, parent, selector, attributeName) => {
  const targetElement = $Q(selector, parent);

  if (!targetElement) return;

  if (attributeName) {
    targetElement.setAttribute(attributeName, element);
  } else {
    targetElement.innerHTML = element;
  }
};


/**
 * Inject new price node to the section
 *
 * @param {HTMLCollection} variantPrice - Object with the price value
 * @param {HTMLElement} parent - Parent node to closest
 * with className 'product-js'
 *
 */
export function updatePrice(variantPrice, parent) {
  const lstSectionPrice = $Qll(".price-product-js", parent);

  lstSectionPrice.forEach((sectionPrice) => {
    sectionPrice.innerHTML = variantPrice;
  })
}

/**
 * Show not available of the variant, depending of the stock
 *
 * @param {String} available - Dataset available
 * @param {HTMLElement} parent - Parent node to closest
 * with className 'product-js'
 * @param {String} newText - New text in button add to cart
 */
export function updateButton(available, parent, newText, isQuickView = false) {
  const button = $Q('.btn-cart-js', parent);
  if (!button) return;
  button.outerHTML = newText;

  if (available === 'false') {
    button.disabled = true;
    if (isQuickView) {
      const newButton = $Q('.btn-cart-js', parent);
      newButton.classList.add('hidden');
    }
  } else {
    button.disabled = false;
  }
}

/**
 * This function updates the href attribute of a button element with a new variant value.
 * @param parent - The parent element that contains the button variant element.
 * @param value - The value parameter is a string that represents the variant value that will be added
 * to the buttonVariant href attribute.
 * @returns If `buttonVariant` is falsy (e.g. `null`, `undefined`, `false`, `0`, `NaN`, or an empty
 * string), the function will return without doing anything. Otherwise, the `href` property of
 * `buttonVariant` will be updated with a new value and the function will not return anything (i.e. it
 * will implicitly return `undefined`).
 */
export function updateButtonVariant(parent, value) {
  const lstButtonVariant = $Qll('.btn-variant-js', parent);

  lstButtonVariant.forEach((buttonVariant) => {
    const urlObj = new URL(buttonVariant.href);
    buttonVariant.href = `${urlObj.origin}${urlObj.pathname}?variant=${value}${urlObj.search}`;
  })
}

/**
 * Update all tags of element
 *
 * @param {HTMLCollection} element - Object with element
 * @param {HTMLElement} parent - Parent node to closest
 *
 */
export const updateTags = (elementTag, parent) => {
  const lstTags = $Qll('.tag-js', parent);
  if (!lstTags) return;

  lstTags.forEach((tag) => {
    tag.outerHTML = elementTag;
  });
}

/**
 * 
 * @param {String} available - Dataset available
 * @param {HTMLElement} parent - Parent node
 * @param {String} productCardButton - Outer string to HTML element
 */
export const updateProductCardButton = (available, parent, productCardButton) => {
  const productCardButtonElement = $Q('.product-card__form-button-js', parent);
  const productAddCart = $Q('.button-card-js', parent);

  if (!productCardButtonElement) return;

  if (available == 'false' && productAddCart) {
    productAddCart.classList.add('hidden');
  } else if (available == 'true' && productAddCart) {
    productAddCart.innerHTML = productAddCart.title;
    productAddCart.disabled = false;
    productAddCart.classList.remove('hidden');
  }

  productCardButtonElement.outerHTML = productCardButton;
}
